import * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';


class Object3D extends THREE.Object3D {
    clear() {
        // Dispose of any geometries
        this.traverse((child) => {

            if (child.geometry) {
                child.geometry.dispose();
            }

        });

        // Dispose of any materials
        this.traverse((child) => {
            if (child.material) {
                if (Array.isArray(child.material)) {
                    child.material.forEach(material => material.dispose());
                } else {
                    child.material.dispose();
                }
            }

        });

        // Additional cleanup as needed (e.g., CSS2DObject elements)
        this.traverse((child) => {
            if (child instanceof CSS2DObject && child.element && child.element.parentNode) {
                child.element.parentNode.removeChild(child.element);
            }
        });

        // If this object is attached to a parent, remove it
        if (this.parent) {
            this.parent.remove(this);
        }
    }
}

export { Object3D };